import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldData, FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { useNavigate } from 'react-router-dom'
import { api } from '@/api'
import {
  IAdminProductROO3,
  IAdminProductCreateO3,
  IAdminProductUpdateO3,
  CategoryEnum,
  StatusEnum4,
} from 'api'
import { apiHelper } from '@/lib/api_helper'

export default function ProductEdit() {
  const navigate = useNavigate()
  const id = useQueryValue('id', 0)

  const { data, refetch } = useApi({
    id: 'productDetail',
    fn: api().adminProduct.getAdminProduct,
    params: Number(id),
    enabled: !!id,
  })

  const onSave = async (formData: IAdminProductROO3) => {
    try {
      if (id) {
        // 수정 로직
        const updateData: IAdminProductUpdateO3 = {
          category: formData.category as CategoryEnum,
          status: formData.status as StatusEnum4,
          title: formData.title,
          titleZhcn: formData.titleZhcn || undefined,
          titleZhtw: formData.titleZhtw || undefined,
          titleEn: formData.titleEn || undefined,
          titleJa: formData.titleJa || undefined,
          titleTh: formData.titleTh || undefined,
          titleMn: formData.titleMn || undefined,
          titleRu: formData.titleRu || undefined,
          content: formData.content,
          contentZhcn: formData.contentZhcn || undefined,
          contentZhtw: formData.contentZhtw || undefined,
          contentEn: formData.contentEn || undefined,
          contentJa: formData.contentJa || undefined,
          contentTh: formData.contentTh || undefined,
          contentMn: formData.contentMn || undefined,
          contentRu: formData.contentRu || undefined,
          code: formData.code,
          codeZhcn: formData.codeZhcn || undefined,
          codeZhtw: formData.codeZhtw || undefined,
          codeEn: formData.codeEn || undefined,
          codeJa: formData.codeJa || undefined,
          codeTh: formData.codeTh || undefined,
          codeMn: formData.codeMn || undefined,
          codeRu: formData.codeRu || undefined,
          price: formData.price,
          thumbnailId: formData.thumbnail?.id,
        }
        await api().adminProduct.updateAdminProduct(Number(id), updateData)
        refetch()
        navigate('/products', { replace: true })
      } else {
        // 생성 로직
        const createData: IAdminProductCreateO3 = {
          category: formData.category as CategoryEnum,
          title: formData.title,
          titleZhcn: formData.titleZhcn || undefined,
          titleZhtw: formData.titleZhtw || undefined,
          titleEn: formData.titleEn || undefined,
          titleJa: formData.titleJa || undefined,
          titleTh: formData.titleTh || undefined,
          titleMn: formData.titleMn || undefined,
          titleRu: formData.titleRu || undefined,
          content: formData.content,
          contentZhcn: formData.contentZhcn || undefined,
          contentZhtw: formData.contentZhtw || undefined,
          contentEn: formData.contentEn || undefined,
          contentJa: formData.contentJa || undefined,
          contentTh: formData.contentTh || undefined,
          contentMn: formData.contentMn || undefined,
          contentRu: formData.contentRu || undefined,
          code: formData.code,
          codeZhcn: formData.codeZhcn || undefined,
          codeZhtw: formData.codeZhtw || undefined,
          codeEn: formData.codeEn || undefined,
          codeJa: formData.codeJa || undefined,
          codeTh: formData.codeTh || undefined,
          codeMn: formData.codeMn || undefined,
          codeRu: formData.codeRu || undefined,
          price: formData.price,
          thumbnailId: formData.thumbnail?.id,
        }
        await api().adminProduct.createAdminProduct(createData)
        navigate('/products', { replace: true })
      }
    } catch (error) {
      console.error('저장 중 오류 발생:', error)
      alert('저장 중 오류가 발생했습니다.')
    }
  }

  const onDelete = async () => {
    if (id) {
      try {
        await api().adminProduct.deleteAdminProduct(Number(id))
        navigate(-1)
      } catch (error) {
        console.error('삭제 중 오류 발생:', error)
        alert('삭제 중 오류가 발생했습니다.')
      }
    }
  }

  console.log(data)

  const columns: FormFieldData<IAdminProductROO3>[] = [
    {
      label: '썸네일',
      key: 'thumbnail',
      type: FormFieldType.FILE,
      accept: 'image/*',
      required: true,
      uploadHandler: apiHelper.uploadImage,
    },
    {
      label: '상품코드 (한국어)',
      key: 'code',
      type: FormFieldType.STRING,
      required: true,
    },
    {
      label: '상품코드 (简体中文)',
      key: 'codeZhcn',
      type: FormFieldType.STRING,
    },
    {
      label: '상품코드 (繁體中文)',
      key: 'codeZhtw',
      type: FormFieldType.STRING,
    },
    {
      label: '상품코드 (English)',
      key: 'codeEn',
      type: FormFieldType.STRING,
    },
    {
      label: '상품코드 (日本語)',
      key: 'codeJa',
      type: FormFieldType.STRING,
    },
    {
      label: '상품코드 (ไทย)',
      key: 'codeTh',
      type: FormFieldType.STRING,
    },
    {
      label: '상품코드 (Монгол)',
      key: 'codeMn',
      type: FormFieldType.STRING,
    },
    {
      label: '상품코드 (Русский)',
      key: 'codeRu',
      type: FormFieldType.STRING,
    },
    {
      label: '카테고리',
      key: 'category',
      type: FormFieldType.SELECT,
      options: [
        { label: '기초케어', value: CategoryEnum.Value기초케어 },
        { label: '진정관리', value: CategoryEnum.Value진정관리 },
        { label: '시술후추천템', value: CategoryEnum.Value시술후추천템 },
      ],
      required: true,
    },
    {
      label: '상품명 (한국어)',
      key: 'title',
      type: FormFieldType.STRING,
      required: true,
    },
    {
      label: '상품명 (简体中文)',
      key: 'titleZhcn',
      type: FormFieldType.STRING,
    },
    {
      label: '상품명 (繁體中文)',
      key: 'titleZhtw',
      type: FormFieldType.STRING,
    },
    {
      label: '상품명 (English)',
      key: 'titleEn',
      type: FormFieldType.STRING,
    },
    {
      label: '상품명 (日本語)',
      key: 'titleJa',
      type: FormFieldType.STRING,
    },
    {
      label: '상품명 (ไทย)',
      key: 'titleTh',
      type: FormFieldType.STRING,
    },
    {
      label: '상품명 (Монгол)',
      key: 'titleMn',
      type: FormFieldType.STRING,
    },
    {
      label: '상품명 (Русский)',
      key: 'titleRu',
      type: FormFieldType.STRING,
    },
    {
      label: '가격',
      key: 'price',
      type: FormFieldType.NUMBER,
      required: true,
    },
    {
      label: '상품상세 (한국어)',
      key: 'content',
      type: FormFieldType.CKEDITOR,
      required: true,
    },
    {
      label: '상품상세 (简体中文)',
      key: 'contentZhcn',
      type: FormFieldType.CKEDITOR,
    },
    {
      label: '상품상세 (繁體中文)',
      key: 'contentZhtw',
      type: FormFieldType.CKEDITOR,
    },
    {
      label: '상품상세 (English)',
      key: 'contentEn',
      type: FormFieldType.CKEDITOR,
    },
    {
      label: '상품상세 (日本語)',
      key: 'contentJa',
      type: FormFieldType.CKEDITOR,
    },
    {
      label: '상품상세 (ไทย)',
      key: 'contentTh',
      type: FormFieldType.CKEDITOR,
    },
    {
      label: '상품상세 (Монгол)',
      key: 'contentMn',
      type: FormFieldType.CKEDITOR,
    },
    {
      label: '상품상세 (Русский)',
      key: 'contentRu',
      type: FormFieldType.CKEDITOR,
    },
  ]

  if (id) {
    columns.push({
      label: '상태',
      key: 'status',
      type: FormFieldType.SELECT,
      options: [
        { label: '노출', value: 'ACTIVE' },
        { label: '미노출', value: 'INACTIVE' },
      ],
    })
    columns.push({
      label: '조회수',
      key: 'viewCount',
      type: FormFieldType.NUMBER,
      readOnly: true,
    })
    columns.push({
      label: '등록일',
      key: 'createDate',
      type: FormFieldType.DATE,
      readOnly: true,
    })
  }

  return (
    <ContentDetailView
      title="상품 수정"
      data={data}
      onSave={onSave}
      onDelete={id ? onDelete : undefined}
    >
      <DetailForm data={data} fields={columns} />
    </ContentDetailView>
  )
}
